import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppEventListener } from 'src/common/events/appEvents';
import { api } from 'src/common/utils/api';
import { useAppContainerContext } from '../AppContainerContext';
import { actionRegistry } from './actions/registry';
import type { SteeringResponse } from './types';

export function useNextBestAction() {
  const { contentMeta } = useAppContainerContext();
  const clientId = contentMeta?.entityId ?? null;
  const queryClient = useQueryClient();
  const queryKey = ['steering', 'next-best-action', clientId];

  const query = useQuery<SteeringResponse | null>({
    queryKey,
    queryFn: async () => {
      const res = await api.post<SteeringResponse>('steering/next-best-action', {
        uiContext: { clientId },
      });
      if (res.data.action === 'NO_SUGGESTION') return null;
      return res.data;
    },
  });

  useAppEventListener(event => {
    const action = query.data?.action;
    if (action && actionRegistry[action]?.completionEvents.includes(event)) {
      queryClient.invalidateQueries({ queryKey: ['steering'] });
    }
  });

  return query;
}
